<p [ngClass]="titleClasses" class="text-2xl">{{ text }}</p>
